import { clsx } from 'clsx'

interface KPICardProps {
  title: string
  value: string | number
  subtitle?: string
  trend?: {
    value: number
    isPositive: boolean
  }
  variant?: 'default' | 'success' | 'warning' | 'danger'
}

export default function KPICard({
  title,
  value,
  subtitle,
  trend,
  variant = 'default',
}: KPICardProps) {
  const formattedValue =
    typeof value === 'number'
      ? new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        }).format(value)
      : value

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
      <p className="text-sm font-medium text-gray-500">{title}</p>
      <p
        className={clsx('text-3xl font-bold mt-2', {
          'text-gray-900': variant === 'default',
          'text-green-600': variant === 'success',
          'text-yellow-600': variant === 'warning',
          'text-red-600': variant === 'danger',
        })}
      >
        {formattedValue}
      </p>
      {(subtitle || trend) && (
        <div className="flex items-center mt-2 space-x-2">
          {trend && (
            <span
              className={clsx('text-sm font-medium', {
                'text-green-600': trend.isPositive,
                'text-red-600': !trend.isPositive,
              })}
            >
              {trend.isPositive ? '↑' : '↓'} {Math.abs(trend.value)}%
            </span>
          )}
          {subtitle && <span className="text-sm text-gray-500">{subtitle}</span>}
        </div>
      )}
    </div>
  )
}
